import { jobstatusActions } from "../../store/jobstatus-slice";
import {
  callOnboardingInventoryOrderSync,
  getOnboardingInventoryOrderSyncStatus,
  getLastSyncStatusTimestamp,
  triggerOrderInventoryManualSync,
  getOngoingSyncJobStatus,
  getLocationSwitchRegenStatus,
} from "../../services/index";
// import { uiActions } from "../../store/ui-slice";
import {
  SEVEN_DAYS_JOB_STATUS,
  SIXTY_DAYS_JOB_STATUS,
  HISTORICAL_JOB_STATUS,
  ONBOARDING_STARTED,
  ONBOARDING_NOT_STARTED,
  ONBOARDING_COMPLETED,
} from "../../config/CONSTANTS";
import { checkOnboardingUserStepsAction } from "./auth-actions";
import { getShopVariantLimit } from "../../services/index";

export const onboardingOrderInventorySyncAction = () => {
  return async (dispatch) => {
    try {
      const limitRes = await getShopVariantLimit();
      if (limitRes.success && limitRes.data && !limitRes.data.allowed) {
        return;
      }
    } catch (err) {
      console.log("onboardingOrderInventorySyncAction limit check err=", err);
    }

    callOnboardingInventoryOrderSync()
      .then((res) => {
        const data = res;
        dispatch(jobstatusActions.setOnboardingJobStatus({ data: data }));
      })
      .catch((err) => {
        console.log("job action  onboardingOrderInventorySyncAction err=", err);
      });

    return () => {};
  };
};

export const onboardingSync7daysStatusAction = () => {
  return async (dispatch) => {
    return getOnboardingInventoryOrderSyncStatus(SEVEN_DAYS_JOB_STATUS)
      .then((res) => {
        const data = res;
        dispatch(jobstatusActions.set7daysjobStatus({ data: data }));
      })
      .catch((err) => {
        console.log("job action  onboardingSync7daysStatusAction err=", err);
      });
  };
};

export const onboardingSync60daysStatusAction = () => {
  return async (dispatch) => {
    return getOnboardingInventoryOrderSyncStatus(SIXTY_DAYS_JOB_STATUS)
      .then((res) => {
        const data = res;
        dispatch(jobstatusActions.set60daysjobStatus({ data: data }));
      })
      .catch((err) => {
        console.log("job action  onboardingSync60daysStatusAction err=", err);
      });
  };
};

export const lastSyncStatusAction = () => {
  return async (dispatch) => {
    return getLastSyncStatusTimestamp()
      .then((res) => {
        const data = res.data;
        dispatch(jobstatusActions.setLastSyncTimestamp({ data: data }));
      })
      .catch((err) => {
        console.log("job action  lastSyncStatusAction err=", err);
      });
  };
};

export const manualOrderInventorySyncAction = () => {
  return async (dispatch) => {
    try {
      const limitRes = await getShopVariantLimit();
      if (limitRes.success && limitRes.data && !limitRes.data.allowed) {
        return;
      }
    } catch (err) {
      console.log("manualOrderInventorySyncAction limit check err=", err);
    }

    triggerOrderInventoryManualSync()
      .then((res) => {
        const data = res;
        dispatch(jobstatusActions.setManualSyncJobStatus({ data: data }));
      })
      .catch((err) => {
        console.log("job action  manualOrderInventorySyncAction err=", err);
      });

    return () => {};
  };
};

export const getOngoingSyncJobStatusAction = () => {
  return async (dispatch) => {
    return getOngoingSyncJobStatus()
      .then((res) => {
        const data = res;
        dispatch(jobstatusActions.setOngoingSyncJobStatus({ data: data }));
      })
      .catch((err) => {
        console.log("job action  getOngoingSyncJobStatusAction err=", err);
      });
  };
};

/*
 * Polls the dedicated backend location-switch regen status.
 *
 * This is the reliable signal (the backend keeps it IN_PROGRESS until the forecast
 * rows are done regenerating), so it replaces the old /bulkOperation/pending guess
 * for ending a switch. The reducer keeps loaders on while inProgress is true and
 * flips ongoingJobStatus true->false (driving the report refetch) once terminal.
 *
 * `res.data` is the ResponseMapper payload: { state, timestamp, locationId, inProgress }.
 */
export const getLocationSwitchRegenStatusAction = () => {
  return async (dispatch) => {
    return getLocationSwitchRegenStatus()
      .then((res) => {
        dispatch(
          jobstatusActions.setLocationSwitchRegenStatus({ data: res?.data || {} })
        );
        return res?.data || {};
      })
      .catch((err) => {
        console.log("job action  getLocationSwitchRegenStatusAction err=", err);
      });
  };
};

/**
 * Fetches job status in order: 7days → 60days → pending → (historical if auth) → lastSync.
 * Pending runs before historical so ongoingJobStatus is set from bulkOperation/pending.
 * Historical runs after pending so we get latest historical job status and can hide the
 * Header progress bar when the historical job finishes (pending returns 0 for that job).
 */
export const fetchJobStatusChainAction = ({ isAuthorizeHistoricalOrders }) => {
  return async (dispatch) => {
    await dispatch(onboardingSync7daysStatusAction());
    await dispatch(onboardingSync60daysStatusAction());
    await dispatch(getOngoingSyncJobStatusAction());
    if (isAuthorizeHistoricalOrders === true) {
      await dispatch(historicalJobStatusAction());
    }
    await dispatch(lastSyncStatusAction());
    dispatch(checkOnboardingUserStepsAction());
  };
};
export const historicalJobStatusAction = () => {
  return async (dispatch) => {
    return getOnboardingInventoryOrderSyncStatus(SIXTY_DAYS_JOB_STATUS)
      .then((res) => {
        const data = res.data;
        if (
          res.asyncInventoryState === ONBOARDING_STARTED &&
          res.asyncOrderState === ONBOARDING_NOT_STARTED
        ) {
          dispatch(
            jobstatusActions.setHistoricaljobStatus({
              status: true,
              data: data,
              asyncInventoryState: res.asyncInventoryState,
              asyncOrderState: res.asyncOrderState,
            })
          );
        } else if (
          // Handle case when both are STARTED - 60-day sync is in progress
          res.asyncInventoryState === ONBOARDING_STARTED &&
          res.asyncOrderState === ONBOARDING_STARTED
        ) {
          dispatch(
            jobstatusActions.setHistoricaljobStatus({
              status: true,
              data: data,
              asyncInventoryState: res.asyncInventoryState,
              asyncOrderState: res.asyncOrderState,
            })
          );
        } else if (
          (res.asyncInventoryState === ONBOARDING_COMPLETED &&
            res.asyncOrderState === ONBOARDING_STARTED) ||
          (res.asyncInventoryState === ONBOARDING_COMPLETED &&
            res.asyncOrderState === ONBOARDING_COMPLETED)
        ) {
          return getOnboardingInventoryOrderSyncStatus(HISTORICAL_JOB_STATUS)
            .then((res) => {
              const data = res;

              dispatch(
                jobstatusActions.setHistoricaljobStatus({
                  status: false,
                  data: data,
                })
              );
            })
            .catch((err) => {
              console.log("ERR on job historicalJobStatusAction action");
            });
        } else {
          dispatch(
            jobstatusActions.setHistoricaljobStatus({
              status: false,
              data: null,
            })
          );
        }
      })
      .catch((err) => {
        console.log("ERR on job historicalJobStatusAction action");
      });
  };
};
